import React from "react";
import ReactDOM from "react-dom";
import "./index.css";
import * as serviceWorker from "./serviceWorker.js";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Landing from './components/landing';
import About from './components/about';
import AboutPage from './components/aboutpage';
import Service from './components/service';
import ServicePage from './components/servicepage';
import Projects from './components/projects';
import ProjectsPage from './components/projectspage';
import Contact from './components/contact';
import ContactPage from './components/contactpage';
import Footer from './components/footer';
import Navigation from './components/Navigation';
import Section1 from './components/service-section1';
import Section2 from './components/service-section2';
import Section3 from './components/service-section3';
import MainSection5 from './components/main-section5';
import Thankyou from './components/thankyou';
import Testimonials from './components/testimonials';
import Mid1 from './components/mid-section1';
import Process from './components/process';
import Project1 from './components/projects/CarsonRoad';
import Project2 from './components/projects/project2';
import Project3 from './components/projects/project3';



function toggleMobileMenu(menu) {
  menu.classList.toggle('open');
}

//this is the links to other pages
ReactDOM.render(

  <Router>
    <Navigation />
    <Routes>
      <Route path="/" element={<>
        <Landing />
        <About />
        <Mid1 />
        <Service />
        <Projects />
        <Contact />
      </>} />
      <Route path="/about" element={<About />} />
      <Route path="/aboutpage" element={<AboutPage />} />
      <Route path="/projectspage" element={<ProjectsPage />} />
      <Route path="/service" element={<>
        <ServicePage />
        <Section1 />
        <Section2 />
        <Section3 />
      </>} />
      <Route path="/servicepage" element={<>
        <ServicePage />
        <Section1 />
        <Section2 />
        <Section3 />
      </>} />
      <Route path="/testimonials" element={<Testimonials />} />
      <Route path="/contact" element={<Contact />} />
      <Route path="/contactpage" element={<ContactPage />} />
      <Route path="/servicepage" element={<ServicePage />} />
      <Route path="/thankyou" element={<Thankyou />} />
      <Route path="/projects/CarsonRoad" element={<Project1 />} />
      <Route path="/projects/project2" element={<Project2 />} />
      <Route path="/projects/project3" element={<Project3 />} />
    </Routes>
    <Footer />
  </Router>,

  document.getElementById("root")
);

serviceWorker.unregister();
//        <Testimonials />
